import CreateCommunicationProgram from './CreateCommunicationProgram';

export default CreateCommunicationProgram;